import { getBasicDeviceData } from '../../util/device.js';
import { getTimezone } from '../../util/date.js';
import { setFieldValue } from '../../util/custom.js';

mpro.getClientData = () => {

	return {
		...getBasicDeviceData(),
		timezone: getTimezone(),
	};
};

mpro.getTimezone = getTimezone;

/**
 * Add init function that is executed on every page/fragment render
 */
mpro.addInitStatic(($container) => {

	// Autofill form fields from js using data-js-autofill attribute
	for (const element of $container.find('[data-js-autofill]')) {
		const $element = $(element);
		const autofillData = $element.data('js-autofill') || {};
		const { method, args = [] } = autofillData;

		if (!method) {
			console.warn('Missing autofill method', $element);
			continue;
		}

		if (typeof mpro[method] !== 'function') {
			console.warn('Invalid autofill method', method, $element);
			continue;
		}

		// Call autofill method and set the result as field value
		const value = mpro[method](...args);
		setFieldValue($element, value && typeof value === 'object' ? JSON.stringify(value) : value);
	}
});

export default mpro;
